import { gql } from '@common/hooks';
import {
  InvoiceItemListDisputeFragment,
  InvoiceItemListDisputeFragmentType,
} from '@pay-bill/graphql/fragments';

export type InvoiceItemTransactionID = 'CREDIT' | 'DEBIT' | 'NEW';

export const InvoiceItemListFragment = gql`
  fragment InvoiceItemListFragment on WorksInvoiceItem {
    id
    date
    hours
    totalSeconds
    payCode
    totalCents
    effectiveHourlyRateCents
    employeeId
    transactionId
    costId
    staffingRequestAssignment {
      id
      employmentType
    }
    supplier {
      id
      name
    }
    resolvedDispute {
      ...ListInvoiceItemDisputeFragment
    }
    dispute {
      ...ListInvoiceItemDisputeFragment
    }
    worksProfile {
      id
      fullName
    }
    worksInvoice {
      id
      code
      preCalculated
    }
    worksReverseInvoice {
      id
      code
    }
    organization {
      id
      name
      payCodes
    }
    organizationProfile {
      id
      employeeId
    }
    canSubmitDispute {
      value
    }
  }
  ${InvoiceItemListDisputeFragment}
`;

export type InvoiceItemListFragmentType = {
  id: string;
  date: string;
  hours: number;
  totalSeconds: number;
  payCode: string | undefined;
  totalCents: number;
  effectiveHourlyRateCents: number;
  staffingRequestType: string;
  employeeId: string | undefined;
  transactionId: InvoiceItemTransactionID;
  costId: string | undefined;
  staffingRequestAssignment: {
    id: string;
    employmentType: string;
  };
  supplier: {
    id: string;
    name: string;
  };
  resolvedDispute: InvoiceItemListDisputeFragmentType | undefined;
  dispute: InvoiceItemListDisputeFragmentType | undefined;
  worksProfile: {
    id: string;
    fullName: string;
  };
  worksInvoice: {
    id: string;
    code: string;
    preCalculated: boolean;
  };
  worksReverseInvoice: {
    id: string;
    code: string;
  };
  organization: {
    id: string;
    payCodes: string[];
    name: string;
  };
  organizationProfile: {
    id: string;
    employeeId: string;
  };
  canSubmitDispute: {
    value: boolean;
  };
};
